export function handleFlashClick(e: MouseEvent): void {
  const target = e.target as HTMLElement;
  const btn = target.closest(".flash__close");
  if (!btn) return;
  const toast = btn.closest(".flash");
  if (toast) toast.remove();
}

document.addEventListener("click", handleFlashClick);

export function scheduleFlashDismissal(): void {
  window.setTimeout(() => {
    document.querySelectorAll(".flash").forEach((el) => el.remove());
  }, 6000);
}

document.addEventListener("turbo:load", scheduleFlashDismissal);
